const vendorList = {
  aws: 'Amazon Web Services',
  azure: 'Microsoft Azure',
  gcp: 'Google Cloud',
};

export const vendors = name => {
  return vendorList[name];
};

/**
 * Vendor Option
 * Return vendors array.
 * @returns {{label: string, value: string}[]}
 */
export const vendorOptions = () => {
  return Object.entries(vendorList).map(val => {
    return {
      label: val[1],
      value: val[0],
    };
  });
};
